import type { TaxonImageShow } from '../effect/schema/openapi/backend';

export enum HrefElementType {
  Anchor = 'anchor',
  Button = 'button',
}

export type CategoryT = {
  name: string; // OK
  slug: string; // OK
  placeholder: string; // -    --> počáteční písmena místo obrázku
  element: HrefElementType; // -    --> <a> nebo <button>
  description: string; // OK
  count: number; // ?
  categories?: CategoryT[] | null; // OK
  brands?: CategoryT[] | null; // -    --> značky v dané kategorii
  current?: boolean; // -
  image?: TaxonImageShow | null; // OK
};

export type TaxonT = {
  '@context': string; // "/api/v2/contexts/Taxon",
  '@id': string; // "/api/v2/shop/taxons/rcprofi-5",
  '@type': string; // "Taxon",
  images: {
    '@id': string; // "/api/v2/shop/taxons/rcprofi-5/images/4",
    '@type': string; // "TaxonImage",
    id: number; // 4,
    type: string; // null
    path: string; //"http://localhost/media/cache/resolve/sylius_original/files/rcprofi-cz/soubory/modulimages/ORxOR/rc-vrtulniky-2.jpg"
  }[];
  id: number; // 41
  code: string; // "rcprofi-5"
  name: string; // "RC vrtulníky"
  slug: string; // "rc-vrtulniky"
  description: string; // "<b>RC vrtulník</b>… sen každého malého kluka, ale i velkého chlapa. Poradíme vám,&nbsp;<a href=\"https://www.rcprofi.cz/poradna/radce/jak-vybrat-rc-vrtulnik.html\">jak vybrat RC vrtulník</a>. Naučíme vás, jak se o něho starat, jak ho ovládat a poradíme se servisem. Pokud by se nějaký akrobatický kousek při letu nepovedl, doporučíme vám <a href=\"https://www.rcprofi.cz/nahradni-dily-rc-vrtulniky.html\">náhradní díly</a>, kterých máme plný sklad. <b>RC vrtulníky</b> z kategorie&nbsp;<a href=\"https://www.rcprofi.cz/rc-vrtulniky/3-kanalove\">3-kanálové</a> jsou určené pro začátečníky, vrtulníky <a href=\"https://www.rcprofi.cz/rc-vrtulniky/4-kanalove\">4-kanálové</a> ocení především mírně pokročilí a vrtulníky&nbsp;<a href=\"https://www.rcprofi.cz/rc-vrtulniky/akrobaticke\">akrobatické</a>&nbsp;zvládne ovládat pouze zkušený pilot. Speciální kategorií jsou <a href=\"https://www.rcprofi.cz/rc-vrtulniky/pro-zacatecniky\">RC vrtulníky pro začátečníky</a>."
  children: string[]; // ["/api/v2/shop/taxons/rcprofi-23", "/api/v2/shop/taxons/rcprofi-616", "/api/v2/shop/taxons/rcprofi-943", "/api/v2/shop/taxons/rcprofi-944"]
};
